const getSubdomain = (): string => {
  const { hostname } = window.location;
  const mainDomainParts = ['avantti', 'io'];

  // Special case for localhost
  if (hostname === 'localhost') {
    return '';
  }

  // Special case for Firebase preview URLs
  if (hostname.endsWith('.web.app')) {
    return '';
  }

  // Universal step: remove 'stg' part as it's for staging.
  const parts = hostname.split('.').filter((part) => part !== 'stg');

  // Check if it's an avantti.io domain by looking at the end of the parts array.
  const isAvanttiDomain = parts.length >= 2
    && parts[parts.length - 2] === mainDomainParts[0]
    && parts[parts.length - 1] === mainDomainParts[1];

  if (isAvanttiDomain) {
    // --- Logic for avantti.io domains ---
    const subdomainParts = parts.slice(0, -2); // Remove 'avantti', 'io'

    if (subdomainParts.length === 0) {
      return ''; // No subdomain (handles avantti.io, stg.avantti.io)
    }

    if (subdomainParts[0] === 'www') {
      // Handles www.producer.avantti.io -> producer
      // Handles www.avantti.io -> ''
      return subdomainParts[1] || '';
    }

    // Handles producer.avantti.io -> producer
    return subdomainParts[0];
  }
  // --- Logic for custom domains (white-label) ---
  // The 'parts' array already has 'stg' removed if it existed.
  if (parts[0] === 'www') {
    return parts[1] || ''; // 'www.custom.com' -> 'custom'
  }
  return parts[0] || ''; // 'custom.com' -> 'custom'
};

export default getSubdomain;
